import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "addCustomCapabilityLink",
    "customCapabilitiesItemTemplate",
    "customCapabilitiesList",
    "dependent",
  ];

  connect() {
    this.syncDependents();
  }

  addCustomCapability(event) {
    event.preventDefault();

    const customCapabilityItemTemplate = this.customCapabilitiesItemTemplateTarget;
    const newCustomCapabilityItem = customCapabilityItemTemplate
      .querySelector(".custom-capability-item-wrapper")
      .cloneNode(true);

    this.customCapabilitiesListTarget.appendChild(newCustomCapabilityItem);
    newCustomCapabilityItem.classList.remove("hidden");
  }

  removeCustomCapability(event) {
    event.preventDefault();

    const customCapabilityItem = event.currentTarget.closest(".custom-capability-item-wrapper");
    const hiddenField = customCapabilityItem.querySelector(".destroy-hidden-field");

    if (hiddenField) {
      hiddenField.value = "true";
      customCapabilityItem.classList.add("hidden");
    } else {
      customCapabilityItem.remove();
    }
  }

  // Sub-options that only apply when a parent capability is on. Each `dependent` target names its parent
  // checkbox via data-capabilities-parent (an element id); when that parent is off (or is itself a
  // disabled dependent) the sub-option is disabled and grayed out. Disabling every field in the wrapper
  // — including a checkbox's hidden companion field — means the stored value is preserved on save rather
  // than reset. Targets are processed in DOM order so the state cascades through nesting
  // (e.g. Cancel Membership → Downsell Plans → downsell offer/reminder emails).
  syncDependents() {
    this.dependentTargets.forEach((wrapper) => {
      const parent = this.element.querySelector(`[id="${wrapper.dataset.capabilitiesParent}"]`);
      if (!parent) return;

      const enabled = parent.checked && !parent.disabled;
      wrapper.querySelectorAll("input, select, textarea").forEach((field) => {
        field.disabled = !enabled;
      });
      wrapper.classList.toggle("opacity-50", !enabled);
      wrapper.classList.toggle("pointer-events-none", !enabled);
    });
  }
}
